(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bgroud-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-bgroud-product-root]');
  roots.forEach((root) => {
    const variantData = root.querySelector('[data-bgroud-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
    const variantMediaScript = root.querySelector('[data-bgroud-variant-image-map]');
    let variantMedia = {};
    try {
      variantMedia = JSON.parse(variantMediaScript?.textContent || '{}');
    } catch (_) {
      variantMedia = {};
    }
    const currency = '{{ cart.currency.iso_code | default: shop.currency }}';
    const locale = document.documentElement.lang || 'en';

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
      }
    };

    const groups = [...root.querySelectorAll('[data-bgroud-option-group]')];

    // Arrange size buttons from smallest to largest without changing
    // the Shopify option values or the variants customers purchase.
    const getSizeRank = (label) => {
      const size = String(label || '').trim().toUpperCase().replace(/[\s._-]+/g, '');
      const namedSizes = {
        'XXS': 0, '2XS': 0, 'EXTRAEXTRASMALL': 0,
        'XS': 1, 'EXTRASMALL': 1,
        'S': 2, 'SMALL': 2,
        'M': 3, 'MEDIUM': 3,
        'L': 4, 'LARGE': 4,
        'XL': 5, 'EXTRALARGE': 5,
        'XXL': 6, '2XL': 6, '2X': 6, 'EXTRAEXTRALARGE': 6,
        'XXXL': 7, '3XL': 7, '3X': 7,
        '4XL': 8, '4X': 8, '5XL': 9, '5X': 9, '6XL': 10, '6X': 10
      };
      if (Object.prototype.hasOwnProperty.call(namedSizes, size)) return namedSizes[size];
      if (/^\d+$/.test(size)) return 100 + Number(size);
      return 999;
    };
    groups.forEach((group) => {
      if (!(group.dataset.optionName || '').toLowerCase().includes('size')) return;
      const container = group.querySelector('.bgroud-product__option-values');
      if (!container) return;
      const buttons = [...container.querySelectorAll(':scope > [data-bgroud-option]')];
      buttons
        .map((button, index) => ({ button, index, rank: getSizeRank(button.dataset.value) }))
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .forEach(({ button }) => container.appendChild(button));
    });

    const selected = () => groups.map((group) => {
      const active = group.querySelector('[data-bgroud-option].is-selected');
      return active ? active.dataset.value : '';
    });

    const updateVariant = () => {
      const values = selected();
      const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
      if (!variant) return;

      const idInput = root.querySelector('[data-bgroud-variant-id]');
      const price = root.querySelector('[data-bgroud-product-price]');
      const add = root.querySelector('[data-bgroud-add]');
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      // Keep the main photo synchronized with the chosen Shopify variant.
      const colorMatch = variants.find((item) => item.option1 === variant.option1 && variantMedia[String(item.id)]);
      const media = variantMedia[String(variant.id)] || (colorMatch ? variantMedia[String(colorMatch.id)] : null);
      if (media && media.src) {
        const thumbs = [...root.querySelectorAll('[data-bgroud-thumb]')];
        const matched = thumbs.find((thumb) => thumb.dataset.mediaId === String(media.id));
        const image = root.querySelector('[data-bgroud-main-image]');
        if (image) {
          image.src = matched?.dataset.image || media.src;
          image.alt = matched?.dataset.alt || media.alt || '';
        }
        if (matched) thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === matched));
      }
    };

    root.addEventListener('click', (event) => {
      const option = event.target.closest('[data-bgroud-option]');
      if (option && option.getAttribute('aria-disabled') !== 'true') {
        const group = option.closest('[data-bgroud-option-group]');
        group.querySelectorAll('[data-bgroud-option]').forEach((button) => {
          const active = button === option;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        const label = group.querySelector('[data-bgroud-option-current]');
        if (label) label.textContent = option.dataset.value || '';
        updateVariant();
        return;
      }

      const minus = event.target.closest('[data-bgroud-qty-minus]');
      const plus = event.target.closest('[data-bgroud-qty-plus]');
      if (minus || plus) {
        const input = root.querySelector('[data-bgroud-qty]');
        if (!input) return;
        const current = Math.max(1, Number(input.value) || 1);
        input.value = minus ? Math.max(1, current - 1) : current + 1;
        return;
      }

      const thumb = event.target.closest('[data-bgroud-thumb]');
      if (thumb) {
        const image = root.querySelector('[data-bgroud-main-image]');
        if (image) {
          image.src = thumb.dataset.image;
          image.alt = thumb.dataset.alt || '';
        }
        root.querySelectorAll('[data-bgroud-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumb));
        return;
      }

      const prev = event.target.closest('[data-bgroud-gallery-prev]');
      const next = event.target.closest('[data-bgroud-gallery-next]');
      if (prev || next) {
        const thumbs = [...root.querySelectorAll('[data-bgroud-thumb]')];
        if (!thumbs.length) return;
        let index = thumbs.findIndex((button) => button.classList.contains('is-active'));
        index = index < 0 ? 0 : index;
        index = prev ? (index - 1 + thumbs.length) % thumbs.length : (index + 1) % thumbs.length;
        thumbs[index].click();
        return;
      }

      const openSizeGuide = event.target.closest('[data-bgroud-open-size-guide]');
      if (openSizeGuide) {
        const sizeTab = root.querySelector('[data-bgroud-tab="size-guide"]');
        if (sizeTab) {
          sizeTab.click();
          root.querySelector('.bgroud-product__details')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }

      const tab = event.target.closest('[data-bgroud-tab]');
      if (tab) {
        const key = tab.dataset.bgroudTab;
        root.querySelectorAll('[data-bgroud-tab]').forEach((button) => button.classList.toggle('is-active', button === tab));
        root.querySelectorAll('[data-bgroud-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.bgroudPanel === key));
      }
    });
    updateVariant();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
